import { render } from "./SSTDatasetNavigation.vue?vue&type=template&id=28ab5d29"
import script from "./SSTDatasetNavigation.vue?vue&type=script&lang=js"
export * from "./SSTDatasetNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script